import type { FC } from 'react'
import { cn } from '@/utils'
import { useSortableCueDropzone } from '../lib/use-sortable-cue-dropzone'
import type { SortableCue } from '../model/types'

type CueSortDropzoneProps = {
  cue: SortableCue
}

export const CueSortDropzone: FC<CueSortDropzoneProps> = ({ cue }) => {
  const { setNodeRef, isOver } = useSortableCueDropzone(cue)

  return (
    <div
      ref={setNodeRef}
      role="none" // a11y: ignore this element
      className={cn(
        'absolute top-0 left-0 right-0 z-10',
        // Height defines a dropzone area.
        // Meaning the zone, at which pointer intersection will trigger `isOver` event.
        'h-1/3',
        !isOver && 'pointer-events-none',
      )}
    >
      {isOver && (
        <div className="absolute top-1.5 right-0 left-0 h-2 border-t-2 border-blue-500 border-dashed" />
      )}
    </div>
  )
}
